module.exports = __webpack_public_path__ + "img/group-m.dfeb7ca7.png";